if ($('#js-excludedMarketsContent').length !== 0) {

    module.exports = {
        init: function () {

            var self = this;

            self.businessContent = $('#js-excludedMarketsContent');
            self.label = $('#bussid');

            $('#js-isbusiness').prop('value', 'true');

            self.label.addClass('required');

        }
    };

}



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/excludedMarketsShowHide.js
// module id = 259
// module chunks = 4